export const enum LabelSentiment {
  unset = "unset",
  neutral = "neutral",
  positive = "positive",
  negative = "negative",
}

export interface CategoricalFeedbackLabel {
  value: string;
  sentiment: LabelSentiment;
}
